export const ConnectWithUsActions = {
  GET_CONNEC_WITH_US: "GET_CONNEC_WITH_US",
  SET_CONNEC_WITH_US: "SET_CONNEC_WITH_US",
  CONTACT_US_FORM_SUBMISSION: "CONTACT_US_FORM_SUBMISSION",
  SET_CONTACT_US_RESPONSE: "SET_CONTACT_US_RESPONSE",

  GET_CONNECT_WITH_US_GFORM: "GET_CONNECT_WITH_US_GFORM",
  SET_CONNECT_WITH_US_GFORM: "SET_CONNECT_WITH_US_GFORM",
};
